import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Segment, Label, Input,
  Divider, Popup, Checkbox, Dimmer, Loader, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import bowser from 'bowser';
import validator from 'validator';
import axios from 'axios';
import { connect } from 'react-redux';
import StepWizard from 'react-step-wizard';

import countries from '../../utils/helpers/countries';
import InfluencerCardPreview from '../influencer-card-preview';

import ThemeSelector from '../../themes/theme-selector';
import hasRESTClient from '../../hocs/has-rest-client';
import hasOrgansation from '../../hocs/has-organisation';
import hasUserInfo from '../../hocs/has-user-info';
import NetworkHandleInput from '../network-handle-input';
import DuplicatedInfluencerError from '../duplicated-influencer-error';

const INF_CREATE_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/signup/influencer';
const EMAIL_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/email/gifta/welcome';
const SHOPFLUENCE_EMAIL_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/email/shopfluence/welcome';
const HANDLE_PROMPT = 'Enter your handle, or copy-paste your profile\'s url';

const SHOW_TELEGRAM = false;

const currentTheme = ThemeSelector.theme();

const submissionLoaderStyle = {
  height: '30vh',
};

const checkboxStyle = {
  'margin-bottom': '25px',
  display: 'flex',
  width: '100%',
  'justify-content': 'center',
};

const blockDisplayStyle = {
  display: 'block',
};

const tagButtonStyle = {
  margin: 5,
};

const middleVertAlign = {
  'vertical-align': 'middle',
};

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const textAlignCentre = {
  'text-align': 'center',
  marginBottom: '15px',
};

const containerStyle = {
  'max-width': '600px',
  margin: 'auto',
  padding: '24px 12px',
};

const blockDisplayFullWidthStyle = {
  display: 'block',
  width: '100%',
};

const grey75TextStyle = {
  color: '#939393',
  'font-size': '0.75rem',
};

const instagramErrorStyle = {
  color: '#20c49e',
  opacity: 1,
};

const youtubeHelpUrl = 'http://help.dyzio.co/en/articles/5543117-adding-an-influencer-s-youtube-channel';


const ELEMIS_DOMAINS = [
  'creators.elemis.com',
];

const preventKeyPressToNext = (event, name, country, email) => {
  if (event.keyCode === 13 && (!name || !country || !email || !validator.isEmail(email))) {
    event.preventDefault();
    console.log('prevent next on enter key press');
  }
};

const InfluencerDetails = (handleChange, name, dob, country, email, contactNumber, SW, sweatcoin) => {
  const { host } = window.location;
  const isElemis = _.includes(ELEMIS_DOMAINS, host);
  return (
    <div>
      {currentTheme.personalDetailHtmlTitle &&
                     currentTheme.personalDetailHtmlTitle()}
      {!currentTheme.personalDetailHtmlTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
      {!currentTheme.formTitle && !currentTheme.personalDetailHtmlTitle &&
      <h3 style={textAlignCentre}>Create your profile</h3>}
      <br />
      {currentTheme.personalDetailHtmlTop && currentTheme.personalDetailHtmlTop()}
      <Form>
        { currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && <Form.Field>
          <Popup
            position="left center"
            trigger={<span>Sweatcoin username<img
              style={middleVertAlign}
              src="/icons/info.svg" alt="info"
            /></span>}
            content="e.g. runner123"
          />
          <Input
            width={16}
            label="@"
            placeholder="Your sweatcoin username"
            name="sweatcoin"
            onChange={handleChange}
            onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
            value={sweatcoin}
            required
          />
        </Form.Field>}
        { currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && <div className="spacer small" />}

        <Form.Input
          width={16}
          label="Name"
          placeholder="Your name"
          name="name"
          onChange={handleChange}
          onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
          value={name}
          required
        />
        <div className="spacer small" />

        { currentTheme.dobRequired && <Form.Input
          width={16}
          label={currentTheme.dobLabel || 'D.O.B'}
          placeholder="e.g. 01/05/2000"
          name="dob"
          onChange={handleChange}
          onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
          value={dob}
          type="date"
          required
        /> }
        { currentTheme.dobRequired && <div className="spacer small" /> }

        <Form.Field required>
          <label htmlFor="country">Country</label>
          <Form.Dropdown
            search
            selection
            width={16}
            value={country}
            name="country"
            options={countries}
            onChange={handleChange}
            onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
            required
          />
          {isElemis && <div style={{ display: 'flex' }}>
            <Icon name="info circle" />
            <span style={{ color: 'rgba(0,0,0,0.4)', marginLeft: '2px' }}>
              Please note: this campaign is only open to creators based in <br /> France, German, Italy or Poland
            </span>
          </div>}
        </Form.Field>
        <Form.Input
          width={16}
          label="Email"
          name="email"
          onChange={handleChange}
          value={email}
          onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
          required
          type="email"
        />

        { email && !validator.isEmail(email) && <div style={{ color: 'red', margin: '1px 2px' }}>invalid email</div> }

        <Form.Input
          width={16}
          label="Contact Number"
          name="contactNumber"
          onChange={handleChange}
          value={contactNumber}
          onKeyDown={e => preventKeyPressToNext(e, name, dob, country, email)}
        />

      </Form>
      {currentTheme.personalDetailHtmlBottom && currentTheme.personalDetailHtmlBottom()}
      <Divider />

      <div
        style={{
          display: 'flow-root',
          width: '100%' }}
      >
        { SW && <Button
          basic={!currentTheme.secondaryButtonColorStyle}
          style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
          color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
          onClick={SW.previousStep}
          size="medium"
          floated="left"
        >
       &larr; back
        </Button>}

        { SW && <Button
          style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
          color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
          size="medium"
          onClick={SW.nextStep}
          floated="right"
          // eslint-disable-next-line max-len
          disabled={!name || !dob || !country || !email || !validator.isEmail(email) || (currentTheme.organisationId === '8cfa2645-50bc-4700-a548-b9bd6e826ec5' && !sweatcoin)}
        >
              next &rarr;
        </Button>}
      </div>
    </div>
  );
};

class InfluencerFormExternal extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor() {
    super();

    this.state = {
      name: '',
      dob: null,
      sweatcoin: null,
      email: '',
      contactNumber: '',
      thumbnail: '',
      primarySocialHandle: '',
      facebook: '',
      facebookPageName: '',
      facebookUserName: '',
      facebookCount: '',
      facebookLoading: false,
      facebookError: false,
      instagram: '',
      instagramUsername: '',
      instagramId: '',
      instagramFullName: '',
      instagramCount: '',
      instagramLoading: false,
      instagramError: false,
      instagramErrorCode: '',
      instagramBusinessAccount: false,
      instagramProfessionalAccount: false,
      instagramCategory: '',
      isFacebookPersonalPage: false,
      instagramPrivate: false,
      twitter: '',
      twitterCount: '',
      twitterLoading: false,
      twitterError: false,
      twitch: '',
      twitchCount: '',
      twitchLoading: false,
      twitchError: false,
      tiktok: '',
      tiktokCount: '',
      tiktokUserId: '',
      tiktokName: '',
      tiktokLoading: false,
      tiktokError: false,
      tiktokVerified: false,
      tiktokThumbnail: '',
      tiktokProfileData: {},
      youtube: '',
      twitchUserId: '',
      youtubeCount: '',
      youtubeErorr: false,
      youtubeLoading: false,
      youtubeChannelTitle: '',
      primarySocialHandleYoutube: false,
      otherChannels: [],
      addChannel: false,
      newChannelName: '',
      newChannelHandle: '',
      handles: [],
      agent: false,
      agentName: '',
      agentEmail: '',
      agentContactNumber: '',
      associated: true,
      contentTags: [],
      brandTags: [],
      addressLine1: '',
      city: '',
      region: '',
      postalCode: '',
      country: '',
      description: '',
      timeout: null,
      web: '',
      snapchat: '',
      linkedin: '',
      tags: [],
      businessUnits: [],
      telegramUser: '',
      telegramFound: '',
      telegramObj: {},
      telegramLoading: false,
      telegramError: false,

      facebookVerified: false,
      twitterVerified: false,
      youtubeVerified: false,
      instagramVerified: false,

      isEmailFieldValid: true,

      duplicateInfluencerHandle: '',
      duplicateInfluencerPlatform: '',
      duplicateInfluencerLinkId: '',

      activeIndex: -1,

      SW: null,
      confirmed: false,
      status: null,
      tagsDropDown: currentTheme.tagsJson ? currentTheme.tagsJson : [],

      tcs: false,
      privacy: false,
      newsletter: false,

      submitting: false,
      newInfluencer: {},
    };
  }

  onSubmit = async e => {
    e.preventDefault();

    const urlParams = new URLSearchParams(window.location.search);
    const signupSource = urlParams.get('source') || urlParams.get('utm_source');

    console.log('signupSource', signupSource);

    const {
      name,
      dob,
      sweatcoin,
      email,
      contactNumber,
      facebook,
      facebookCount,
      instagram,
      instagramId,
      instagramCount,
      twitter,
      twitterCount,
      youtube,
      youtubeCount,
      instagramBusinessAccount,
      instagramPrivate,
      instagramProfessionalAccount,
      instagramCategory,
      country,
      twitch,
      twitchCount,
      tiktokUserId,
      thumbnail,
      tiktok,
      tiktokCount,
      newsletter,
      tagsDropDown,
    } = this.state;

    const selectedTags = _.filter(tagsDropDown, t => t.selected);
    const tags = _.map(selectedTags, st => ({
      id: st.id,
      type: st.type,
    }));

    const foundCreator = {
      full_name: '',
      contactNumber,
      tiktokUserId,
      thumbnail,
      instagramId,
      followerCount: instagramCount,
      username: instagram,
      tiktok,
      tiktokCount,
      twitter,
      twitterCount,
      youtube,
      youtubeCount,
      facebook,
      facebookCount,
      twitch,
      twitchCount,
      tags,
      isVerified: true,
      instagramBusinessAccount,
      instagramProfessionalAccount,
      instagramCategory,
      isPrivate: instagramPrivate,
      id: instagramId,
      usageRightsGranted: !!newsletter,
      signupSource,
    };

    console.log(foundCreator);

    const cleanFoundCreator = _.pickBy(foundCreator);

    console.log(cleanFoundCreator);

    const data = {
      country,
      email,
      name,
      dob,
      sweatcoin,
      tags,
      foundCreator: cleanFoundCreator,
      organisationId: currentTheme.organisationId || 'efcb872a-50d9-417c-b6a5-ba427dba4c84',
      organisationName: currentTheme.title,
      device: bowser.mobile ? 'mobile' : 'desktop',
      deviceSource: bowser,
    };

    console.log(data);

    const cleanData = _.pickBy(data);

    console.log(cleanData);

    const emailParams = {
      recipient: email,
      name,
    };

    this.setState({
      submitting: true,
    });

    return axios.post(INF_CREATE_API, { data: cleanData })
      .then(async r => {
        if (currentTheme.organisationId === '2beaa438-af69-46f1-b639-f7ae1f374241') {
          await axios.post(EMAIL_API, emailParams)
            .then(res => { console.log('email', res); })
            .catch(err => { console.log(err); });
        }

        const shopfluenceParams = {
          email,
          name,
          organisationId: currentTheme.organisationId,
        };
        await axios.post(SHOPFLUENCE_EMAIL_API, shopfluenceParams)
          .then(res => { console.log('email', res); })
          .catch(err => { console.log(err); });

        const { status, data: { body, statusCode } } = r;
        console.log(status);
        console.log(body);

        const { data: { influencer, exists } } = JSON.parse(body);
        console.log(influencer);
        if (_.isEqual(statusCode, 201)) {
          console.log('created');
          this.setState({
            confirmed: true,
            status: 'created',
            newInfluencer: influencer,
          });
        } else {
          console.log('NOT created');
          this.setState({
            confirmed: true,
            status: exists ? 'exist' : 'failed',
          });
        }
      });
  };

  revertDuplicateHandleChannelError = channel => {
    const { duplicateInfluencerPlatform } = this.state;
    if (_.eq(channel, duplicateInfluencerPlatform)) {
      this.setState({
        duplicateInfluencerHandle: null,
        duplicateInfluencerPlatform: null,
        duplicateInfluencerLinkId: null,
      });
    }
  }

  getChannelData = async (channel, handle) => {
    const count = `${channel}Count`;
    const loading = `${channel}Loading`;
    const error = `${channel}Error`;
    const thumbnail = `${channel}Thumbnail`;
    this.revertDuplicateHandleChannelError(channel);

    if (channel === 'instagram') {
      this.setState({
        instagramError: false,
        instagramErrorCode: '',
        name: '',
        thumbnail: null,
        primarySocialHandle: null,
        [count]: '',
      });
    }

    const options = {
      data: {
        platform: channel,
        name: _.trimStart(handle, '@'),
      },
    };

    this.setState({
      [loading]: true,
    });

    if (handle.length === 0) {
      const details = {
        [loading]: false,
        [count]: 0,
        [error]: false,
        [thumbnail]: '',
      };
      switch (channel) {
      case 'facebook':
        details.facebookPageName = null;
        details.facebookUserName = null;
        details.facebookVerified = false;
        break;
      case 'instagram':
        details.instagramFullName = null;
        details.instagramUserName = null;
        details.instagramVerified = false;
        break;
      case 'twitter':
        details.twitterPageName = null;
        details.twitterUserName = null;
        details.twitterVerified = false;
        break;
      case 'youtube':
        details.youtubeChannelTitle = null;
        details.youtubeChannelUserName = null;
        details.youtubeVerified = false;
        break;
      case 'twitch':
        details.name = null;
        details.twitchChannelTitle = null;
        details.twitchUserId = null;
        break;
      case 'tiktok':
        details.tiktokName = null;
        details.tiktokVerified = false;
        break;
      case 'telegram':
        details.telegramUser = null;
        details.telegramFound = 0;
        details.telegramObj = {};
        break;
      default: break;
      }
      return this.setState({
        ...details,
      });
    }

    return axios
      .post(process.env.REACT_APP_GET_INFLUENCER_DATA_URL, options)
      .then(response => {
        if (_.isEqual(channel, 'instagram') && response.data.statusCode === 500) {
          this.setState({
            instagramErrorCode: 'NO_MATCH',
          });
        }

        this.setState({
          [loading]: false,
          [count]: response.data.body.data.followerCount,
          [error]: false,
          [thumbnail]: response.data.body.data.thumbnail,
        });

        const country = response.data.body.data.location;

        const details = {};
        switch (channel) {
        case 'facebook':
          details.facebookPageName = response.data.body.data.pagename;
          details.facebookUserName = response.data.body.data.username;
          details.facebookVerified = response.data.body.data.verified;
          details.isFacebookPersonalPage = response.data.body.data.isPersonalPage;
          this.revertDuplicateHandleChannelError('facebook');
          break;
        case 'instagram':
          // details.name = response.data.body.data.full_name;
          details.instagramFullName = response.data.body.data.full_name;
          details.instagramUserName = response.data.body.data.username;
          details.instagramVerified = response.data.body.data.isVerified;
          details.instagramBusinessAccount = response.data.body.data.instagramBusinessAccount;
          details.instagramPrivate = response.data.body.data.isPrivate;
          details.instagramProfessionalAccount = response.data.body.data.instagramProfessionalAccount;
          if (response.data.body.data.instagramCategory) {
            details.instagramCategory = response.data.body.data.instagramCategory;
          }
          details.instagramId = response.data.body.data.id;
          this.revertDuplicateHandleChannelError('instagram');
          break;
        case 'twitter':
          details.twitterUserName = response.data.body.data.screen_name;
          details.twitterVerified = response.data.body.data.verified;
          this.revertDuplicateHandleChannelError('twitter');
          break;
        case 'youtube':
          details.youtubeChannelTitle = response.data.body.data.channelTitle;
          details.youtubeChannelUserName = response.data.body.data.username;
          details.youtubeVerified = response.data.body.data.verified;
          this.revertDuplicateHandleChannelError('youtube');
          break;
        case 'twitch':
          details.twitchChannelTitle = response.data.body.data.name;
          details.twitchUserId = response.data.body.data.userId;
          this.revertDuplicateHandleChannelError('twitch');
          break;
        case 'tiktok':
          details.tiktokName = response.data.body.data.name;
          details.tiktokVerified = response.data.body.data.verified;
          details.tiktokThumbnail = response.data.body.data.thumbnail;
          details.tiktokProfileData = response.data.body.data;
          details.tiktokUserId = response.data.body.data.id;
          this.revertDuplicateHandleChannelError('tiktok');
          break;
        default: break;
        }

        const newState = _.assign({
          country,
          shouldRenderSocialHandlesBlock: true,
        }, details);

        if (channel === 'instagram' || channel === 'tiktok') {
          newState.thumbnail = response.data.body.data.thumbnail;
          newState.primarySocialHandle = `@${response.data.body.data.username}`;
        }

        this.setState(newState);

        const { handles, youtubeChannelTitle } = this.state;
        const o = {
          key: channel,
          value: channel,
          text: channel === 'youtube' ? `${youtubeChannelTitle} (${channel})` : `${handle} (${channel})`,
        };
        const a = handles.filter(obj => obj.key !== channel);
        a.push(o);
        this.setState({ handles: a });
      })
      .catch(e => {
        // if instagramErrorCode not set to NO_MATCH then it is a genuine error
        console.log(e);
        const { instagramErrorCode } = this.state;
        if (!instagramErrorCode) {
          if (_.isEqual(channel, 'instagram')) {
            this.setState({
              instagramErrorCode: 'ERROR',
            });
          }
        }
        this.setState({ [loading]: false, [error]: true });
      });
  }

  componentDidMount = () => {
    console.log('componentDidMount');
  }

  componentWillReceiveProps = (newProps, oldProps) => {
    if (newProps.organisation
      && newProps.userInfo
      && _.get(newProps, 'organisation.name') !== _.get(oldProps, 'organisation.name')
    ) {
      this.checkLimitsNotification();
    }
  }

  checkboxChange = (e, v) => {
    const { name, value } = v;
    this.setState({
      [name]: !value,
    });
  };

  handleChange = (e, v) => {
    this.setState({
      [v.name]: v.value,
    });
  };

  handleTagChange = (e, v) => {
    const { name, value } = v;
    this.setState({
      [name]: value,
    });
  };

  onInfluencerEmailStateChanged = (isValid, value) => {
    this.setState({
      isEmailFieldValid: isValid,
      email: value,
    });
  }

  handleBasicSocialChange = (e, v) => {
    const { name, value } = v;
    this.setState({
      [name]: _.replace(value, /\s/g, ''),
    });
  };

  handleSocialChange = (e, v) => {
    const value = _.replace(_.get(v, 'value'), /\s/g, '');
    this.setState({ [v.name]: value });
    this.getChannelData(v.name, value);
  };

  retryInstagramHandle = () => {
    const { instagram } = this.state;
    console.log('retry search for instagram handle', instagram);
    this.getChannelData('instagram', instagram);
  };

  handleChannelAdd = () => {
    const { newChannelName, newChannelHandle, otherChannels } = this.state;
    const obj = {
      name: newChannelName,
      handle: newChannelHandle,
    };
    otherChannels.push(obj);
    this.setState({ otherChannels, newChannelName: '', newChannelHandle: '' });
  }

  handleChannelRemove = (name, handle) => {
    const { otherChannels } = this.state;
    const a = otherChannels.filter(o => o.name !== name);
    this.setState({ otherChannels: a });
  }

  onTagSelected = tagId => {
    const { tags: selectedTags } = this.state;
    const tags = _.concat(selectedTags, [tagId]);
    this.setState({
      tags,
    });
  }

  onUnselected = tagId => {
    const { tags: selectedTags } = this.state;
    const tags = _.reject(selectedTags, tag => tag === tagId);
    this.setState({
      tags,
    });
  }

  setInstance = SW => this.setState({
    SW,
  });

  handleStepChange = (x, y) => {
    console.log(x, y);

    if (window.gtag) {
      const newState = _.omit(this.state, 'SW');
      console.log(newState);
      window.gtag('event', 'form_step_change', {
        step_number: x.activeStep,
        step_name: `step_${x.activeStep}`,
        form_data: JSON.stringify(newState),
      });
    }
  }

  render() {
    const {
      name,
      dob,
      sweatcoin,
      email,
      thumbnail,
      contactNumber,
      country,
      primarySocialHandle,
      facebook,
      facebookCount,
      facebookLoading,
      facebookError,
      instagram,
      instagramCount,
      instagramLoading,
      instagramError,
      instagramErrorCode,
      twitter,
      twitterCount,
      twitterLoading,
      twitterError,
      youtube,
      youtubeChannelTitle,
      youtubeCount,
      youtubeLoading,
      youtubeError,

      primarySocialHandleYoutube,
      isFacebookPersonalPage,


      twitch,
      twitchCount,
      twitchError,
      twitchLoading,

      tiktok,
      tiktokCount,
      tiktokLoading,
      tiktokError,

      telegramUser,
      telegramFound,
      telegramError,
      telegramLoading,

      duplicateInfluencerHandle,
      duplicateInfluencerPlatform,
      duplicateInfluencerLinkId,
      SW,
      confirmed,
      status,

      tcs,
      privacy,
      newsletter,

      submitting,
      newInfluencer,
    } = this.state;

    const duplicateErrorProps = {
      duplicateInfluencerHandle,
      duplicateInfluencerPlatform,
      duplicateInfluencerLinkId,
    };

    const disableActionButtons1 =
    facebookLoading ||
    twitterLoading ||
    tiktokLoading ||
    facebookError ||
    twitterError ||
    tiktokError;

    const disableActionButtons2 =
    twitchLoading ||
    youtubeLoading ||
    twitchError ||
    youtubeError;

    const Welcome = () => (
      <div>
        {currentTheme.formTitle && currentTheme.formTitle()}
        {!currentTheme.formTitle &&
        <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {currentTheme.welcomeHtml && currentTheme.welcomeHtml()}
        {!currentTheme.welcomeHtml && <div style={minHeight200}>
          <p style={textAlignCentre}>welcome to {currentTheme.title}.</p>
          <br />
          <p style={textAlignCentre50p}>Join our creator network and we will review your profile and
          feed and work to partner you with brands who are looking for influencers.</p>
          <br />
        </div>}
        <Divider />

        <div
          style={{
            display: 'flow-root',
            width: '100%' }}
        >
          { SW && <Button
            style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
            color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
            size="medium"
            onClick={SW.nextStep}
            floated="right"
          >
                  next &rarr;
          </Button>}
        </div>
      </div>
    );

    const Instagram = () => {
      const isInstagramReady = (instagram && !instagramLoading && !instagramError);
      const isTikTokReady = (tiktok && !tiktokLoading && !tiktokError);

      const shouldEnableNextButton = currentTheme.tiktokOnFrontPage
        ? isTikTokReady || isInstagramReady
        : isInstagramReady;

      return (
        <div>
          {currentTheme.socialHandle1HtmlTitle &&
                     currentTheme.socialHandle1HtmlTitle()}
          {!currentTheme.socialHandle1HtmlTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
          {!currentTheme.formTitle && !currentTheme.socialHandle1HtmlTitle &&
          <h3 style={textAlignCentre}>Create your profile</h3>}
          <br />
          {currentTheme.socialHandle1HtmlTop && currentTheme.socialHandle1HtmlTop()}
          <div style={minHeight200}>
            <Popup
              position="left center"
              trigger={<span style={blockDisplayStyle}>{currentTheme.instagramLabel || 'Instagram'}<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
              content={HANDLE_PROMPT}
            />
            <Form>
              <Form.Group widths="equal">
                <Form.Field error={instagramError}>
                  <NetworkHandleInput
                    fromComponent="signup"
                    network="instagram"
                    error={instagramError}
                    value={instagram}
                    loading={instagramLoading}
                    onChange={this.handleSocialChange}
                    count={instagramCount}
                    placeholder={currentTheme.instagramPlaceholder || null}
                  />
                  {
                    _.isEqual(instagramErrorCode, 'ERROR') &&
                    <Label basic color="red" pointing>
              Sorry… the search failed, <a style={instagramErrorStyle} onClick={this.retryInstagramHandle}>click here</a> to try again!
                    </Label>
                  }
                  {
                    _.isEqual(instagramErrorCode, 'NO_MATCH') &&
                    <Label basic color="red" pointing>
              Sorry we could not find that username, please check it and try again!
                    </Label>
                  }
                  <DuplicatedInfluencerError {...duplicateErrorProps} platform="instagram" />
                </Form.Field>
              </Form.Group>

              {
                !instagramLoading && !instagramError && instagram && instagramCount &&
                <div style={textAlignCentre}>
                  <Label as="p" basic color="blue">
                    <Icon name="check" /> Found {instagram}
                  </Label>
                  <br />
                </div>
              }
              {
                instagramLoading &&
                <div style={textAlignCentre}>
                  <Label as="p" basic color="teal">
                    <Icon name="search" /> Searching...
                  </Label>
                  <br />
                </div>
              }
              { currentTheme.tiktokOnFrontPage &&
              <Popup
                position="left center"
                trigger={<span style={blockDisplayStyle}>{currentTheme.tiktokLabel || 'Tiktok'}<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
                content={HANDLE_PROMPT}
              />}
              { currentTheme.tiktokOnFrontPage &&
              <Form.Group widths="equal">
                <Form.Field error={tiktokError}>
                  <NetworkHandleInput
                    fromComponent="signup"
                    network="tiktok"
                    error={tiktokError}
                    value={tiktok}
                    loading={tiktokLoading}
                    onChange={this.handleSocialChange}
                    count={tiktokCount}
                    placeholder={currentTheme.tiktokPlaceholder || null}
                  />
                  {
                    _.isEqual(tiktokError, 'NO_MATCH') &&
                    <Label basic color="red" pointing>
              Sorry we could not find that username, please check it and try again!
                    </Label>
                  }
                  <DuplicatedInfluencerError {...duplicateErrorProps} platform="tiktok" />
                </Form.Field>
              </Form.Group>}
              {
                currentTheme.tiktokOnFrontPage && !tiktokLoading && !tiktokError && tiktok && tiktokCount &&
                <div style={textAlignCentre}>
                  <Label as="p" basic color="blue">
                    <Icon name="check" /> Found {tiktok}
                  </Label>
                  <br />
                </div>
              }
              {
                currentTheme.tiktokOnFrontPage && tiktokLoading &&
                <div style={textAlignCentre}>
                  <Label as="p" basic color="teal">
                    <Icon name="search" /> Searching...
                  </Label>
                  <br />
                </div>
              }
            </Form>


          </div>
          {currentTheme.socialHandle1HtmlBottom && currentTheme.socialHandle1HtmlBottom()}
          <Divider />

          <div
            style={{
              display: 'flow-root',
              width: '100%' }}
          >
            { SW && <Button
              style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
              color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
              size="medium"
              onClick={SW.nextStep}
              floated="right"
              disabled={!shouldEnableNextButton}
            >
                  next &rarr;
            </Button>}
          </div>


        </div>
      );
    };

    const toggleTag = tagId => {
      const { tagsDropDown } = this.state;
      console.log(tagId);
      _.forEach(tagsDropDown, t => {
        if (t.id === tagId) {
          t.selected = !t.selected;
        }
      });
      this.setState({
        tagsDropDown,
      });
    };

    const Tags = () => {
      const { tagsDropDown } = this.state;

      return (
        <div>
          {currentTheme.tagsTitle &&
                     currentTheme.tagsTitle()}
          {!currentTheme.tagsTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
          {!currentTheme.formTitle && !currentTheme.tagsTitle &&
          <h3 style={textAlignCentre}>Create your profile</h3>}
          {currentTheme.tagsHtmlTop && currentTheme.tagsHtmlTop()}
          {
            _.map(tagsDropDown, tag => (
              <Button
                size="small"
                style={tagButtonStyle}
                color={currentTheme.tagButtonColor ? currentTheme.tagButtonColor : 'pink'}
                inverted={!tag.selected}
                onClick={() => toggleTag(tag.id)}
                onKeyDown={e => preventKeyPressToNext(e)}
              >
                {_.get(tag, 'attributes.value')}
              </Button>
            ))
          }
          {currentTheme.tagsHtmlBottom && currentTheme.tagsHtmlBottom()}
          <Divider />

          <div
            style={{
              display: 'flow-root',
              width: '100%' }}
          >
            { SW && <Button
              basic={!currentTheme.secondaryButtonColorStyle}
              style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
              color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
              onClick={SW.previousStep}
              size="medium"
              floated="left"
            >
          &larr; back
            </Button>}

            { SW && <Button
              style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
              color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
              size="medium"
              onClick={SW.nextStep}
              floated="right"
            >
                  next &rarr
            </Button>}
          </div>
        </div>);
    };

    const SocialHandles = () => (
      <div>
        {currentTheme.socialHandle2HtmlTitle &&
                     currentTheme.socialHandle2HtmlTitle()}
        {!currentTheme.socialHandle2HtmlTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
        {!currentTheme.formTitle && !currentTheme.socialHandle2HtmlTitle &&
        <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {currentTheme.socialHandle2HtmlTop && currentTheme.socialHandle2HtmlTop()}
        <Popup
          position="left center"
          trigger={<span style={blockDisplayStyle}>Facebook<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
          content={HANDLE_PROMPT}
        />
        <Form>
          <Form.Group widths="equal">
            <Form.Field error={facebookError}>
              <NetworkHandleInput
                fromComponent="signup"
                network="facebook"
                error={facebookError}
                value={facebook}
                loading={facebookLoading}
                onChange={this.handleSocialChange}
                count={facebookCount}
                isPersonalPage={isFacebookPersonalPage}
              />
              <DuplicatedInfluencerError {...duplicateErrorProps} platform="facebook" />
            </Form.Field>

          </Form.Group>

          <Popup
            position="left center"
            trigger={<span style={blockDisplayStyle}>Twitter<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
            content={HANDLE_PROMPT}
          />

          <Form.Group widths="equal">
            <Form.Field error={twitterError}>
              <NetworkHandleInput
                fromComponent="signup"
                network="twitter"
                error={twitterError}
                value={twitter}
                loading={twitterLoading}
                onChange={this.handleSocialChange}
                count={twitterCount}
              />
              <DuplicatedInfluencerError {...duplicateErrorProps} platform="twitter" />
            </Form.Field>
          </Form.Group>

          <Popup
            position="left center"
            trigger={<span style={blockDisplayStyle}>{currentTheme.tiktokLabel || 'Tiktok'}<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
            content={HANDLE_PROMPT}
          />

          <Form.Group widths="equal">
            <Form.Field error={tiktokError}>
              <NetworkHandleInput
                fromComponent="signup"
                network="tiktok"
                error={tiktokError}
                value={tiktok}
                loading={tiktokLoading}
                onChange={this.handleSocialChange}
                count={tiktokCount}
              />
              <DuplicatedInfluencerError {...duplicateErrorProps} platform="tiktok" />
            </Form.Field>
          </Form.Group>
        </Form>
        {currentTheme.socialHandle2HtmlBottom && currentTheme.socialHandle2HtmlBottom()}
        <Divider />

        <div
          style={{
            display: 'flow-root',
            width: '100%' }}
        >
          { SW && <Button
            basic={!currentTheme.secondaryButtonColorStyle}
            style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
            color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
            onClick={SW.previousStep}
            size="medium"
            floated="left"
          >
          &larr; back
          </Button>}

          { SW && <Button
            style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
            color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
            size="medium"
            onClick={SW.nextStep}
            floated="right"
            disabled={disableActionButtons1}
          >
                  next &rarr;
          </Button>}
        </div>
      </div>
    );

    const MoreSocialHandles = () => (
      <div>
        {currentTheme.socialHandle3HtmlTitle &&
                     currentTheme.socialHandle3HtmlTitle()}
        {!currentTheme.socialHandle3HtmlTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
        {!currentTheme.formTitle && !currentTheme.socialHandle3HtmlTitle &&
        <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {currentTheme.socialHandle3HtmlTop && currentTheme.socialHandle3HtmlTop()}
        <Popup
          position="left center"
          trigger={<span style={blockDisplayStyle}>Twitch<img style={middleVertAlign} src="/icons/info.svg" alt="info" /></span>}
          content={HANDLE_PROMPT}
        />
        <Form>
          <Form.Group widths="equal">
            <Form.Field error={twitchError}>
              <NetworkHandleInput
                fromComponent="signup"
                network="twitch"
                error={twitchError}
                value={twitch}
                loading={twitchLoading}
                onChange={this.handleSocialChange}
                count={twitchCount}
              />
              <DuplicatedInfluencerError {...duplicateErrorProps} platform="twitch" />
            </Form.Field>
          </Form.Group>


          { (currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c') && <span style={blockDisplayFullWidthStyle}>YouTube -
            <span style={grey75TextStyle}>
              Please use Channel ID or Handle, username is not accepted.
            </span>
            <a href={youtubeHelpUrl} target="blank" >
              <img style={middleVertAlign} src="/icons/info.svg" alt="info" />
            </a>
          </span>}

          { (currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c') && <Form.Group widths="equal">
            <Form.Field error={youtubeError}>
              <NetworkHandleInput
                fromComponent="signup"
                network="youtube"
                error={youtubeError}
                value={youtube}
                loading={youtubeLoading}
                onChange={this.handleSocialChange}
                count={youtubeCount}
              />
              <DuplicatedInfluencerError {...duplicateErrorProps} platform="youtube" />
            </Form.Field>
          </Form.Group>}

          {
            (currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c') && youtubeChannelTitle &&
              <div><Label size="large" color="green" basic>{youtubeChannelTitle}</Label></div>
          }
          {
            (currentTheme.organisationId !== '0aff8cfc-4b27-4c18-9806-87cb83f2b01c') && !youtubeChannelTitle &&
            <div><Label size="large" color="grey" basic>{
              youtubeLoading
                ? 'loading...'
                : 'Youtube Channel Title'
            }</Label></div>
          }
          <br />
        </Form>
        {currentTheme.socialHandle3HtmlBottom && currentTheme.socialHandle3HtmlBottom()}
        <Divider />

        <div
          style={{
            display: 'flow-root',
            width: '100%' }}
        >
          { SW && <Button
            basic={!currentTheme.secondaryButtonColorStyle}
            style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
            color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
            onClick={SW.previousStep}
            size="medium"
            floated="left"
          >
          back
          </Button>}

          { SW && <Button
            style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
            color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
            size="medium"
            onClick={SW.nextStep}
            floated="right"
            disabled={disableActionButtons2}
          >
                  next &rarr;
          </Button>}
        </div>
      </div>
    );

    const SignUpMessage = () => (
      <div>
        {currentTheme.signUpTitle &&
                     currentTheme.signUpTitle()}
        {!currentTheme.signUpTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
        {!currentTheme.formTitle && !currentTheme.signUpTitle &&
          <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {currentTheme.signUpHtml && currentTheme.signUpHtml()}
        <Divider />

        <div
          style={{
            display: 'flow-root',
            width: '100%' }}
        >
          { SW && <Button
            basic={!currentTheme.secondaryButtonColorStyle}
            style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
            color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
            onClick={SW.previousStep}
            size="medium"
            floated="left"
          >
          back
          </Button>}

          { SW && <Button
            style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
            color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
            size="medium"
            onClick={SW.nextStep}
            floated="right"
          >
                  next &rarr;
          </Button>}
        </div>
      </div>
    );

    const Confirmation = () => (
      <div>
        { !submitting &&
        <div>
          {currentTheme.confirmationTitle &&
                     currentTheme.confirmationTitle()}
          {!currentTheme.confirmationTitle && currentTheme.formTitle &&
                     currentTheme.formTitle()}
          {!currentTheme.formTitle && !currentTheme.confirmationTitle &&
          <h3 style={textAlignCentre}>Create your profile</h3>}
          <br />
          <div style={checkboxStyle}>
            <Checkbox
              // label={}
              name="tcs"
              value={tcs}
              checked={tcs}
              onChange={this.checkboxChange}
            /> <span style={{ marginLeft: 10 }}>I accept {currentTheme.shopfluenceTitle || currentTheme.title} <a
              target="_blank"
              rel="noopener noreferrer"
              href={currentTheme.tAndCUrl || 'https://shopfluence.app/terms-and-conditions/'}
            >T&Cs</a></span>
          </div>
          <div style={checkboxStyle}>
            <Checkbox
              // label={}
              name="privacy"
              value={privacy}
              checked={privacy}
              onChange={this.checkboxChange}
            /> <span style={{ marginLeft: 10 }}>I accept {currentTheme.shopfluenceTitle || currentTheme.title} <a
              target="_blank"
              rel="noopener noreferrer"
              href={currentTheme.ppUrl || 'https://shopfluence.app/privacy-policy/'}
            >Privacy Policy</a></span>
          </div>
          {!currentTheme.hideLastCheckbox && <div style={checkboxStyle}>
            <Checkbox
              name="newsletter"
              value={newsletter}
              checked={newsletter}
              onChange={this.checkboxChange}
            /> {currentTheme.extraCheckboxHtml ? currentTheme.extraCheckboxHtml() :
              `Sign me up to ${currentTheme.title} influencer newsletter`}
          </div>}
          <Divider />

          <div
            style={{
              display: 'flow-root',
              width: '100%' }}
          >
            { SW && <Button
              basic={!currentTheme.secondaryButtonColorStyle}
              style={currentTheme.secondaryButtonColorStyle ? currentTheme.secondaryButtonColorStyle : null}
              color={currentTheme.secondaryButtonColorStyle ? null : 'black'}
              onClick={SW.previousStep}
              size="medium"
              floated="left"
            >
        back
            </Button>}

            <Button
              style={currentTheme.primaryButtonColorStyle ? currentTheme.primaryButtonColorStyle : null}
              color={currentTheme.primaryButtonColorStyle ? null : 'pink'}
              size="medium"
              onClick={this.onSubmit}
              disabled={!tcs || !privacy}
              floated="right"
            >
                Submit
            </Button>
          </div>
        </div>
        }
        { submitting &&
          <div>
            {currentTheme.formTitle && currentTheme.formTitle()}
            {!currentTheme.formTitle &&
            <h3 style={textAlignCentre}>Create your profile</h3>}
            <br />
            <Segment style={submissionLoaderStyle}>
              <Dimmer active inverted>
                <Loader inverted size="large">Your application is being submitted</Loader>
              </Dimmer>
            </Segment>
          </div>
        }
      </div>
    );


    const Finished = () => (
      <div>
        {currentTheme.formTitle && currentTheme.formTitle()}
        {!currentTheme.formTitle &&
        <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {currentTheme.finishedHtml && currentTheme.finishedHtml(newInfluencer)}
        {newInfluencer && currentTheme.typeForm && currentTheme.typeForm(newInfluencer)}
      </div>
    );

    const Failed = () => (
      <div>
        {currentTheme.formTitle && currentTheme.formTitle()}
        {!currentTheme.formTitle &&
        <h3 style={textAlignCentre}>Create your profile</h3>}
        <br />
        {status === 'exist' &&
        <div style={minHeight200}>
          <p style={textAlignCentre}>
            You have already signed up.
          </p>
          <br />
        </div>}
        {status === 'failed' &&
        <div style={minHeight200}>
          <p style={textAlignCentre}>
            A problem has occured during your sign up, please try again.
          </p>
          <br />
        </div>}
      </div>
    );

    return (
      <div className="page">
        <div style={containerStyle}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <InfluencerCardPreview
                  primarySocialHandleYoutube={primarySocialHandleYoutube}
                  youtubeChannelTitle={youtubeChannelTitle}
                  name={name}
                  thumbnail={thumbnail}
                  facebookCount={facebookCount}
                  twitterCount={twitterCount}
                  youtubeCount={youtubeCount}
                  instagramCount={instagramCount}
                  tiktokCount={tiktokCount}
                  telegramFound={telegramFound}
                  primarySocialHandle={primarySocialHandle}
                  showTelegram={SHOW_TELEGRAM}
                  instagramLoading={instagramLoading}
                  brandLogo={currentTheme.useLogoOnPreview ? currentTheme.headerLogo : null}
                />

                <Segment>
                  {/* <Form error> */}
                  { !confirmed &&
                    <StepWizard
                      onStepChange={this.handleStepChange}
                      instance={this.setInstance}
                    >
                      <Welcome />
                      <Instagram />
                      {InfluencerDetails(this.handleChange, name, dob, country, email, contactNumber, SW, sweatcoin)}
                      {currentTheme.tagsJson && <Tags />}
                      {!currentTheme.skipMainHandles && <SocialHandles />}
                      {!currentTheme.skipAdditionalHandles && <MoreSocialHandles />}
                      {currentTheme.signUpHtml && <SignUpMessage />}
                      <Confirmation />
                    </StepWizard>}

                  {/* </Form> */}

                  { confirmed && status === 'created' && <Finished />}
                  { confirmed && status !== 'created' && <Failed />}
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
});

export default hasUserInfo(hasRESTClient(hasOrgansation(connect(mapStateToProps)(InfluencerFormExternal))));



/** WEBPACK FOOTER **
 ** ./src/components/influencer-form-external/index.js
 **/